import BaseEvaluator from './BaseEvaluator';

export default class RequiredEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'required';
  }

  validate() {
    this.isValid = this.value !== undefined && this.value !== null && this.value !== '';
    return this.isValid;
  }
}
